import React from 'react';

import Framework from "@beardeddevops/react.framework";
import FeEstimates from "../../../../../components/Containers/FeEstimates";

export default class WeeklyEstimates extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar history={history}/>

				<FeEstimates history={history} id={this.props.user}/>

			</div>
		)
	}
}